module.exports = __webpack_public_path__ + "static/media/min-logo.32213262.png";